let _ = require('../_.js');
var $ = jQuery;


/* This file contains helper jquery functions or behaviors that are purely about logic.  Individual custom components defined 
  as jquery methods are in component.js. */

// Async callback methods for jquery animate functions.  Methods are prefixed with "a" as in aFadeOut.
let jquery_methods_to_hook = ['fadeIn', 'fadeOut', 'slideUp', 'slideDown'];

$.each(jquery_methods_to_hook, function (index, method) {
    let promiseMethod = 'a' + method.charAt(0).toUpperCase() + method.slice(1);

    $.fn[promiseMethod] = function (speed = 300, callback = null) {
        let $target = this;
        return new Promise((resolve, reject) => {
            // Animation will not start if it's unnecessary, so we need to handle these cases
            if ((method === 'fadeOut' && !this.is(':visible')) ||
                (method === 'fadeIn' && this.is(':visible')) ||
                (method === 'slideUp' && !this.is(':visible')) ||
                (method === 'slideDown' && this.is(':visible'))) {
                if (typeof (callback) == "function") {
                    callback.bind(this)();
                }
                resolve();
            } else {
                $target[method](speed, function () {
                    if (typeof (callback) == "function") {
                        callback.bind(this)();
                    }
                    resolve();
                });
            }
        });
    };
});

// Async animate function.
$.fn.aAnimate = function (properties, duration = 400, easing = "swing") {
    const element = this; // Save the reference to the element
    return new Promise((resolve, reject) => {
        element.animate(properties, duration, easing, function () {
            resolve();
        });
    });
};

// Async get function.  Waits for the callback to complete before it resolves.
$.aGet = function (url) {
    return new Promise((resolve, reject) => {
        $.get(url, function (data) {
            resolve(data);
        });
    });
};

// Jquery selector getComputedStyle - calls window.getComputedStyle on element
$.fn.getComputedStyle = function () {
    var element = this[0]; // Get the DOM element from the jQuery object
    return window.getComputedStyle(element);
};

// Jquery selector set_conditional_class.  
// classname gets added or removed from element depending on if set_class value is true/false
$.fn.set_conditional_class = function (classname, value) {
    return this.each(function () {
        var $element = $(this);
        if (value && !$element.hasClass(classname)) {
            $element.addClass(classname);
            // _.ui_update();
        } else if (!value && $element.hasClass(classname)) {
            $element.removeClass(classname);
            // _.ui_update();
        }
    });
};

// Jquery selector set_conditional_visibility.  
// hide / show element based on passed value
$.fn.set_conditional_visibility = function (value) {
    return this.each(function () {
        var $element = $(this);
        if (value) {
            $element.show();
            // _.ui_update();
        } else if (!value) {
            $element.hide();
            // _.ui_update();
        }
    });
};

// Fires callback whenever a target overflow-y:scroll div element scrolls to the end of the div
$.fn.scrolled_to_end = function (callback, px_from_end = 50) {
    return this.each(function () {
        var $this = $(this);

        function checkScroll() {
            var scrollTopMax = this.scrollHeight - $this.outerHeight();
            if (scrollTopMax - $this.scrollTop() <= px_from_end) {
                callback.call(this);
            }
        }

        // Call checkScroll immediately to handle case when the entire overflow area is visible
        checkScroll.call(this);

        $this.on('scroll', function () {
            checkScroll.call(this);
        });
    });
};

// Returns true if the selected element is 
$.fn.is_element_in_viewport = function () {
    if (!this.is(":visible")) {
        return false;
    }
    try {
        let el = this[0];

        const rect = el.getBoundingClientRect();

        let element_top = rect.top;
        let element_bottom = rect.bottom;
        let window_height = $(window).height();

        return ((element_top > 0 && element_top < window_height) ||
            (element_bottom < window_height && element_bottom > 0) ||
            (element_top < 0 && element_bottom > window_height)
        );
    } catch (e) {
        return false;
    }
};

// Checks if the selected element has a value of true.  Explicitly
// is looking for the string value 'true' but also accounts for other variations
// of things indicating the value is true.
$.fn.is_true = function () {
    let val = $(this).val();
    if (typeof val === 'string') {
        val = val.toLowerCase();
        if (val === 'true') return true;
        if (val === 'false') return false;
    } else if (typeof val === 'boolean') {
        return val;
    }
    return Boolean(Number(val));
};


// Returns selected elements value as a decoded json value
$.fn.from_json = function () {
    return JSON.parse($(this).val());
};


// Sort elements such that parents always come before their children
$.fn.sortElements = function () {
    return this.sort(function (a, b) {
        return $.contains(a, b) ? -1 : $.contains(b, a) ? 1 : 0;
    });
};



// Fade in / fade out / slide up / slide down:
// - Wait for existing animation to complete
// - Do nothing if the element is already in desired visibility state
// - If passed speed is 0, just calls show/hide
(function ($) {

    $.fn.oFadeIn = $.fn.fadeIn;
    $.fn.oFadeOut = $.fn.fadeOut;
    $.fn.oSlideUp = $.fn.slideUp;
    $.fn.oSlideDown = $.fn.slideDown;

    $.fn.fadeIn = function () {
        var args = arguments;
        var callback = args[1] ? args[1] : function () { };
        return this.each(function () {
            var $this = $(this);
            if ($this.is(":animated")) {
                $this.promise().done(function () {
                    if ($this.not(":visible")) {
                        if (args[0] === 0) {
                            $this.show();
                            callback.call(this);
                        } else {
                            $.fn.oFadeIn.apply($this, args).promise().done(function () {
                                callback();
                                _.ui_update();
                            });
                            _._ui_resize_immediate();
                        }
                    } else {
                        callback.call(this);
                    }
                    _.ui_update();
                });
            } else if ($this.not(":visible")) {
                if (args[0] === 0) {
                    $this.show();
                    callback.call(this);
                } else {
                    $.fn.oFadeIn.apply($this, args).promise().done(function () {
                        callback();
                        _.ui_update();
                    });
                    _._ui_resize_immediate();
                }
            } else {
                callback.call(this);
            }
            _.ui_update();
        });
    };

    $.fn.fadeOut = function () {
        var args = arguments;
        var callback = args[1] ? args[1] : function () { };
        return this.each(function () {
            var $this = $(this);
            if ($this.is(":animated")) {
                $this.promise().done(function () {
                    if ($this.is(":visible")) {
                        if (args[0] === 0) {
                            $this.hide();
                            callback.call(this);
                        } else {
                            $.fn.oFadeOut.apply($this, args).promise().done(function () {
                                callback();
                                _.ui_update();
                            });
                        }
                    } else {
                        callback.call(this);
                    }
                    _.ui_update();
                });
            } else if ($this.is(":visible")) {
                if (args[0] === 0) {
                    $this.hide();
                    callback.call(this);
                } else {
                    $.fn.oFadeOut.apply($this, args).promise().done(function () {
                        callback();
                        _.ui_update();
                    });
                }
            } else {
                callback.call(this);
            }
            _.ui_update();
        });
    };

    $.fn.slideUp = function () {
        var args = arguments;
        var callback = args[1] ? args[1] : function () { };
        return this.each(function () {
            var $this = $(this);
            if ($this.is(":animated")) {
                $this.promise().done(function () {
                    if ($this.is(":visible")) {
                        if (args[0] === 0) {
                            $this.hide();
                            callback.call(this);
                        } else {
                            $.fn.oSlideUp.apply($this, args).promise().done(function () {
                                callback();
                                _.ui_update();
                            });
                        }
                    } else {
                        callback.call(this);
                    }
                    _.ui_update();
                });
            } else if ($this.is(":visible")) {
                if (args[0] === 0) {
                    $this.hide();
                    callback.call(this);
                } else {
                    $.fn.oSlideUp.apply($this, args).promise().done(function () {
                        callback();
                        _.ui_update();
                    });
                }
            } else {
                callback.call(this);
            }
            _.ui_update();
        });
    };

    $.fn.slideDown = function () {
        var args = arguments;
        var callback = args[1] ? args[1] : function () { };
        return this.each(function () {
            var $this = $(this);
            if ($this.is(":animated")) {
                $this.promise().done(function () {
                    if ($this.not(":visible")) {
                        if (args[0] === 0) {
                            $this.show();
                            callback.call(this);
                        } else {
                            $.fn.oSlideDown.apply($this, args).promise().done(function () {
                                callback();
                                _.ui_update();
                            });
                            _._ui_resize_immediate();
                        }
                    } else {
                        callback.call(this);
                    }
                    _.ui_update();
                });
            } else if ($this.not(":visible")) {
                if (args[0] === 0) {
                    $this.show();
                    callback.call(this);
                } else {
                    $.fn.oSlideDown.apply($this, args).promise().done(function () {
                        callback();
                        _.ui_update();
                    });
                    _._ui_resize_immediate();
                }
            } else {
                callback.call(this);
            }
            _.ui_update();
        });
    };

    let text_width_test_canvas;

    function get_text_width_test_canvas() {
        if (!text_width_test_canvas) {
            text_width_test_canvas = document.createElement("canvas").getContext("2d");
        }
        return text_width_test_canvas;
    }

    $.fn.fit_text_to_area = function (text, initialFontSize, margin) {
        return this.each(function () {
            let $this = $(this);
            text = text + ""; // cast to string
            if ($this.text() == text) {
                return;
            }
            $this.text('');
            let fontSize = initialFontSize;
            let computed = window.getComputedStyle(this);
            do {
                get_text_width_test_canvas().font = computed['font-weight'] + " " + fontSize + "px " + computed['font-family'];
                let text_width = get_text_width_test_canvas().measureText(text.trim()).width;
                let available_width = $this.innerWidth();
                if (text_width <= (available_width - (margin * 2)) || fontSize <= 8) {
                    break;
                } else {
                    fontSize--;
                }
            } while (true);
            $this.css('font-size', fontSize + "px");
            $this.text(text);
            return this;
        });
    };

    // Same as .text(), but with nl_to_br
    //?
    $.fn.text_with_br = function (text) {
        this.empty();
        const lines = text.split(/\n/);
        const html = lines.map(line => $('<span>').text(line).html()).join('<br />');
        this.html(html);
        return this;
    }

    // Creates a UL / LI list on target element with one LI per entry in passed array 'data'.
    $.fn.array_to_ul = function (data, css_class = null) {
        this.empty();
        const ul = $('<ul>');
        if (css_class) {
            ul.addClass(css_class);
        }
        data.forEach(item => {
            $('<li>').text(item).appendTo(ul);
        });
        this.append(ul);
        return this;
    };

    // Like .css(), but only reads the style attribute, never reads computed values
    $.fn.style = function (cssProp, value) {
        // Handling the "get" scenario
        if (value === undefined && typeof cssProp === 'string') {
            var styleAttr = this.attr('style'); // Get the 'style' attribute
            if (styleAttr) {
                // Parse the 'style' attribute
                var styles = styleAttr.split(';').reduce(function (acc, current) {
                    var parts = current.split(':').map(function (item) { return item.trim(); });
                    if (parts[0] && parts[1]) {
                        acc[parts[0]] = parts[1];
                    }
                    return acc;
                }, {});
                return styles[cssProp]; // Return the requested style property
            }
            return undefined; // Property not found
        }
        // Handling the "set" scenario
        else {
            return this.css(cssProp, value); // Delegate to jQuery's .css() method
        }
    };

    // Like .css(), but only reads the style attribute, never reads computed values
    // Explicitly returns integer values in place of something like 10px, also allows to set by integer (value 3 becomes 3px)
    // Returns 0 in situation of property not found.
    $.fn.styleInt = function (cssProp, value) {
        // Handling the "get" scenario
        if (value === undefined && typeof cssProp === 'string') {
            var styleAttr = this.attr('style'); // Get the 'style' attribute
            if (styleAttr) {
                // Parse the 'style' attribute
                var styles = styleAttr.split(';').reduce(function (acc, current) {
                    var parts = current.split(':').map(function (item) { return item.trim(); });
                    if (parts[0] && parts[1]) {
                        acc[parts[0]] = parts[1];
                    }
                    return acc;
                }, {});
                let styleVal = styles[cssProp];
                if (styleVal) {
                    styleVal = styleVal.replace(/[^\d.]+/g, '');
                    if (styleVal.length > 0) {
                        return parseInt(styleVal);
                    }
                }
            }
            return 0; // Default to 0
        }
        // Handling the "set" scenario
        else {
            if (value) {
                value = parseInt(value);
                if (this.styleInt(cssProp) != value) {
                    return this.css(cssProp, value + "px");
                } else {
                    return this;
                }
            } else {
                return this.css(cssProp, value);
            }
        }
    };


    // Explicitly returns integer values in place of something like 10px, also allows to set by integer (value 3 becomes 3px)
    // Returns 0 in situation of property not found.
    $.fn.cssInt = function (cssProp, value) {
        // Handling the "get" scenario
        if (value === undefined && typeof cssProp === 'string') {
            let val = this.css(cssProp);
            val = val.replace('px', '');
            val = parseInt(val);
            return val;
        }
        // Handling the "set" scenario
        else {
            if (value) {
                value = parseInt(value);
                if (this.cssInt(cssProp) != value) {
                    return this.css(cssProp, value + "px");
                } else {
                    return this;
                }
            } else {
                return this.css(cssProp, value);
            }
        }
    };

    // Given selected select element, replace options on the element with passed in object of key value pairs
    $.fn.populate_options = function (options) {
        // `this` refers to the jQuery object that the function is called on
        return this.each(function () {
            // Ensure this function is only applied to select elements
            if (!$(this).is('select')) {
                console.error('populate_options can only be applied to <select> elements.');
                return;
            }

            // Clear all current options
            $(this).empty();

            // Iterate over the options object and create new <option> elements
            $.each(options, function (key, data) {
                $(this).append($('<option></option>').val(key).text(data.label));
            }.bind(this));  // bind `this` to ensure correct context inside $.each
            return this;
        });
    };

})(jQuery);


// Modify .ajax so it queues and only processes up to 20 requests at once, and retries up to 3 times on 500 response.
(function ($) {

    // Store the original version of $.ajax
    const originalAjax = $.ajax;

    // Variables for the queuing system
    const queue = [];
    let activeCount = 0;
    const maxSimultaneousRequests = 20;

    function processQueue() {
        if (activeCount < maxSimultaneousRequests && queue.length > 0) {
            activeCount++;
            const { options, resolve, reject } = queue.shift();

            // Execute the request using the retry logic
            ajaxWithRetry(options).then(resolve).catch(reject).finally(() => {
                activeCount--;
                processQueue();
            });
        }
    }

    // Retry logic wrapped around the original $.ajax
    async function ajaxWithRetry(options, retries = 3, delay = 2000) {
        try {
            let response = await originalAjax(options);
            return response;
        } catch (error) {
            if (error.status === 500 && retries > 0) {
                await new Promise(resolve => setTimeout(resolve, delay));
                return ajaxWithRetry(options, retries - 1, delay + 2000);
            }
            throw error;
        }
    }

    // Override $.ajax to include both queueing and retry logic
    $.ajax = function (options) {
        return new Promise((resolve, reject) => {
            queue.push({ options, resolve, reject });
            processQueue();
        });
    };
})(jQuery);

// Global copy event handler - automatically trims copied text
// This removes leading and trailing whitespace from any text copied to clipboard
document.addEventListener('copy', function(event) {
    // Don't trim if user is holding Shift (allows copying with whitespace if needed)
    if (event.shiftKey) return;

    let selection = window.getSelection();
    let selectedText = selection.toString();

    // Don't trim if selection is empty
    if (!selectedText) return;

    // Don't trim if copying from code blocks, textareas, or content-editable (preserve formatting)
    let container = selection.getRangeAt(0).commonAncestorContainer;
    if (container.nodeType === 3) container = container.parentNode; // Text node to element
    if (container.closest('pre, code, .code-block, textarea, [contenteditable="true"]')) return;

    let trimmedText = selectedText.trim();

    // Only modify if there's actually whitespace to trim
    if (trimmedText !== selectedText && trimmedText.length > 0) {
        event.preventDefault();
        event.clipboardData.setData('text/plain', trimmedText);
        console.log('Copy: trimmed whitespace from selection');
    }
});